"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _fuse = _interopRequireDefault(require("fuse.js"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _ProductCardList = _interopRequireDefault(require("./ProductCardList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProductSearch = function ProductSearch(_ref) {
  var products = _ref.products,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Producten' : _ref$title,
      loading = _ref.loading,
      openProduct = _ref.openProduct,
      labels = _ref.labels;
  var fuseSearchMemoized = (0, _react.useMemo)(function () {
    if (loading) {
      return null;
    }

    var options = {
      keys: ['key', 'title'],
      shouldSort: true,
      threshold: 0.3
    };
    var fuse = new _fuse["default"](products, options);
    return (0, _ramda.memoizeWith)(_ramda.identity, function (search) {
      return fuse.search(search);
    });
  }, [loading, products ? products.length : 0]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var filteredProducts = search === '' || loading ? (0, _ramda.sortBy)((0, _ramda.prop)('renderTitle'))(products) : fuseSearchMemoized(search);
  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, {
    title: title,
    actions: /*#__PURE__*/_react["default"].createElement(_solarReact2.ResponsiveSearchField, {
      InputProps: {
        id: 'searchCertificates'
      },
      placeholder: labels.search,
      value: search,
      onChange: function onChange(value) {
        return setSearch(value);
      }
    })
  }), loading ? /*#__PURE__*/_react["default"].createElement(_core.LinearProgress, {
    color: "primary"
  }) : '', /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, null, /*#__PURE__*/_react["default"].createElement(_ProductCardList["default"], {
    products: filteredProducts,
    openProduct: openProduct,
    noAvatar: true
  })));
};

var _default = ProductSearch;
exports["default"] = _default;